import { Typography, useMediaQuery, useTheme } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AcnColorTheme } from "../../assets/css/AcnColorTheme";
import "../../assets/css/App.css";
import chaiyo from '../../assets/img/chaiyo2.png';
import DynamicTitle from "../../component/DynamicTitle";
import TemplateComponent from "../../component/template/TemplateComponent";
import { UserInfoModel } from "../../models/UserInfoModel";
import { RootState } from "../../store";
import { actions as UserAction } from "../../store/redux/UserInfoRedux";
import { NavTo } from "../../utils/AppManager";
import { Path } from "../../utils/Constant";
import { fontUnit, padGinUnit } from "../../utils/DeviceManager";

function LoginScreen(props: any) {
    const dispatch = useDispatch();
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('sm'));
    const [userInfo] = useSelector((state: RootState) => [
        state.userInfoReducer.userInfo
    ]);
    const [message, setMessage] = useState("")

    const onLogin = () => {
        const lineId = props.match.params.lineId
        if (lineId && lineId.length > 10) {
            const lineId = props.match.params.lineId
            const newInfo: UserInfoModel = {...userInfo, lineUserId: lineId}
            UserAction.setUserInfo(dispatch, newInfo).then(() => {
                NavTo(Path.nationalId)
            })
        } else {
            setMessage("ลิงก์นี้ไม่อยู่อีกต่อไป หรือหมดอายุแล้ว กรุณาลองใหม่อีกครั้ง")
        }
    }

    useEffect(() => {
        document.title = "สมัครใช้งาน\u200E\u200E\u200E"
        const lineId = props.match.params.lineId
        if (lineId && lineId.length <= 10) {
            setMessage("ลิงก์นี้ไม่อยู่อีกต่อไป หรือหมดอายุแล้ว กรุณาลองใหม่อีกครั้ง")
        }

        // Clear userInfo state every time user lands on login page
        (async function() {
            await UserAction.initUserInfo(dispatch);
        })();
    }, [dispatch, props.match.params.lineId])

    const loginWidget = () => {
        return (
            <div style={{display: 'flex',justifyContent: 'center',flexDirection: 'column',overflow: "hidden"}}>
                <div>
                    <img 
                        src={chaiyo} 
                        alt={"logo"}
                        style={{
                            width: !isDesktop ? window.innerWidth : '75vw',
                        }}
                    /> 
                    <div style={{paddingLeft: padGinUnit(24), paddingRight: padGinUnit(24), marginTop: padGinUnit(16)}}>
                        <DynamicTitle title={"สวัสดีคร้าบบบ"} size={fontUnit(32)} isFontWeightMediumStyle={true}/>
                        <DynamicTitle title={"ยินดีต้อนรับเข้าสู่\nไลน์ Chaiyo Connect"} size={fontUnit(24)} paddingTop={padGinUnit(16)} isFontWeightMediumStyle={true}/>
                        {
                            message.length > 0 ? (
                                <Typography style={{fontSize: fontUnit(16), marginTop: padGinUnit(16), color: AcnColorTheme.danger}}>
                                    {message}
                                </Typography>) : <div/>
                        }
                    </div>
                </div>
            </div>
        );
    }

    return (
        <TemplateComponent content={loginWidget()}
                           onNext={onLogin}
                           isCanNext={message.length <= 0}
                           nextText={"ลงทะเบียนใช้งาน"}
                           showHeadBar={false}
                           background={AcnColorTheme.primary}
                           noPadding
        />
    );
}

export default LoginScreen;
